export const state = {
    dialog: false,
    genericCategories: {},
    genericCategoriesArray: [],
    perPage: 10,
    searchText: "",
};
export const mutations = {
    setDialog(state, data) {
        state.dialog = data;
    },
    setPerPage(state, data) {
        state.perPage = data;
    },
    setSearchText(state, data) {
        state.searchText = data;
    },
    setGenericCategories(state, data) {
        state.genericCategories = data;
    },
    setGenericCategoriesArray(state, data) {
        state.genericCategoriesArray = data;
    },
};

export const actions = {
    async changeDialog(context, data) {
        context.commit("setDialog", data);
    },
    async changeGenericCategories(context, data) {
        context.commit("setGenericCategories", data);
    },
    async changeGenericCategoriesArray(context, data) {
        context.commit("setGenericCategoriesArray", data);
    },
    async changePerPage(context, data) {
        context.commit("setPerPage", data);
    },
    async changeSearchText(context, data) {
        context.commit("setSearchText", data);
    },
};